//////////////////
// IMPORTS
//////////////////
// schema
// libraries
import { Person } from "@clockwise/schema";
import * as React from "react";
import { connect } from "react-redux";
// selection-scheduler imports
import * as s from "./ProfileCollaborators.styles";
import { IContainer, IProps } from "./ProfileCollaboratorsTypes";
// other components
import { A, H2 } from "#webapp/src/components/ui";
// util
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";

// state
import { setActiveViewCalendarProfile } from "#webapp/src/state/actions/chrome-extension.actions";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
// material-ui
import { Divider } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class ProfileCollaboratorsComponent extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  private onButtonClick = (calendarId: string) => {
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    this.props.setActiveViewCalendarProfile(calendarId);
    track(TrackingEvents.TEAM_HEALTH.SUMMARY_GO_TO_PROFILE, { calendarId, from: "THProfile" });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { org } = this.props;

    const topCollaborators =
      org.collaboratorStatsErrorable &&
      org.collaboratorStatsErrorable.__typename !== "GraphEntityError" &&
      org.collaboratorStatsErrorable.topCollaborators;

    if (!topCollaborators) {
      return null;
    }

    // gen personMap
    const personMap: { [calId: string]: Person } = {};
    let showCollaborators = false;
    if (org.personsByCalendarIdsErrorable.__typename === "PersonList") {
      showCollaborators = true;
      const persons = org.personsByCalendarIdsErrorable.list;
      persons.forEach((p) => (personMap[p.primaryEmail] = p));
    }

    // gen collabs
    const collaborators = topCollaborators.filter(
      (tc) => tc?.calendarId && !!personMap[tc.calendarId],
    );
    if (!showCollaborators || !collaborators.length) {
      return null;
    }

    return (
      <div>
        <Divider style={s.divider} />
        <H2 style={s.title}>Top collaborators</H2>
        <ol style={{ paddingBottom: 8 }}>
          {collaborators.slice(0, 5).map((tc, i) => {
            if (!tc || !tc.calendarId || !tc.sharedMinutes) return null;
            const person = personMap[tc.calendarId];
            return (
              <div key={i} style={s.collaborator.container}>
                <div>
                  <span style={s.collaborator.number}>{i + 1}.</span>
                  <A
                    onClick={() => {
                      if (!tc.calendarId) return;
                      this.onButtonClick(tc.calendarId);
                    }}
                    style={s.collaborator.name}
                  >
                    {person && person.profile ? (
                      <span>
                        {person.profile.givenName} {person.profile.familyName}
                      </span>
                    ) : (
                      person.primaryEmail
                    )}
                  </A>
                </div>
                <div>{Math.round(tc.sharedMinutes / 60)} hr</div>
              </div>
            );
          })}
        </ol>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const ProfileCollaborators = connect(mapStateToProps, {
  setActiveViewCalendarProfile,
})(ProfileCollaboratorsComponent);
